import {handleAPI, API_VERSION_ONE} from '../../../itrust_common/utils/apiUtils';
const parent = 'PUBLIC_'

export function staffAvailableSlotsLoad(staff_id, filters){
  const url = `/anonymous/${API_VERSION_ONE}/staffs/${staff_id}/available_slots`;
  const method = 'GET'

  return {
    type: `${parent}STAFFS_AVAILABLE_SLOTS_LOAD`,
    payload: handleAPI(url, filters, method)
  };
}

export function staffUnAvailableSlotsLoad(staff_id, filters) {
  const url = `/anonymous/${API_VERSION_ONE}/staffs/${staff_id}/unavailable_dates`;
  const method = 'GET'

  return {
    type: `${parent}STAFFS_UNAVAILABLE_DATES_LOAD`,
    payload: handleAPI(url, filters, method)
  };
}

export function staffAvailableSlotsDump() {
  return {
    type: `${parent}STAFFS_AVAILABLE_SLOTS_DUMP`,
  };
}

export function staffUnAvailableDatesDump() {
  return {
    type: `${parent}STAFFS_UNAVAILABLE_DATES_DUMP`,
  };
}

export function staffId(id) {
  return {
    type: `${parent}STAFF_ID`,
    id,
  };
}